import { RestaurantQRCodesListFull } from "@/screens/restaurants/details/restaurant.qrcodes.list";
import { Stack, useLocalSearchParams } from "expo-router";

export default function FullList() {
  const { orgId } = useLocalSearchParams<{ orgId: string }>();

  return (
    <>
      <Stack.Screen options={{ title: "QR codes" }} />
      <RestaurantQRCodesListFull organizationId={orgId} />
    </>
  );
}
